







































import { Vue, Component, Prop } from "vue-property-decorator";
import MainObject from "./main-object.vue";
@Component({
  name: "ObjectLayout",
  components: { MainObject }
})
export default class ObjectLayout extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  private meta!: any;

  @Prop({
    type: Object,
    default: () => ({})
  })
  private data!: any;

  get keys(): any[] {
    return this.meta.formLabelKeys;
  }

  get rows(): number {
    return Math.ceil(this.keys.length / 2);
  }
}
